import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ThemeMainMenu from './ThemeMainMenu';
import SideBar from '../sidebar/SideBar';
import MobileMenu from './MobileMenu';
import progressbar from "../../components/progress-bar/Progressbar";

const ThemeMenuOne = () => {
    const [sticky, setSticky] = useState(false);
    const [showSidebar, setShowSidebar] = useState(false);
    const [menu, setMenu] = useState("");

    const openSidebar = () => setShowSidebar(true);
    const closeSidebar = () => setShowSidebar(false);
    const showMobilemenu = () => setMenu('show');
    const hideMobilemenu = () => setMenu("");

    useEffect(() => {
        const stickyMenu = () => {
            if (window.scrollY >= 60) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };
        window.addEventListener('scroll', stickyMenu);
        return () => window.removeEventListener('scroll', stickyMenu);
    }, []);

    const completion = progressbar();

    return (
        <Fragment>
            <SideBar onClick={closeSidebar} value={showSidebar} />
            <header className="theme-main-menu">
                <div className={sticky ? "main-header-area sticky-menu" : "main-header-area"}>
                    <div className="container-fluid custom-container-nav">
                        <div className="row align-items-center">
                            {/* Logo Alanı - %15-20 yer kaplar */}
                            <div className="col-lg-2 col-6 text-start">
                                <div className="logo-area">
                                    <Link to="/">
                                        <img src="assets/img/logo/header-logo.PNG" alt="cruxestack" style={{ maxHeight: '55px', marginTop:'10px' }} />
                                    </Link>
                                </div>
                            </div>

                            {/* Menü Alanı - %70-80 yer kaplar, böylece kategoriler yayılır */}
                            <div className="col-lg-8 d-none d-lg-block ">
                                <nav className="navbar navbar-expand-lg justify-content-center">
                                    {/* justify-content-center kategorileri merkeze yayar */}
                                    <div className="collapse navbar-collapse justify-content-center mt-2" id="navbarSupportedContent">
                                        <ThemeMainMenu />
                                    </div>
                                </nav>
                            </div>

                            {/* Sağ Nav (Hamburger) - %5-10 yer kaplar */}
                            <div className="col-lg-2 col-6 text-end">
                                <ul className="right-nav mb-0 d-flex align-items-center justify-content-end list-unstyled">
                                    <li>
                                        <div className="hamburger-menu">
                                            <div className="d-none d-lg-inline-block">
                                                <button className="round-menu bg-transparent border-0" onClick={openSidebar}>
                                                    <i className="bi bi-list" style={{ fontSize: '30px', color: 'white' }} />
                                                </button>
                                            </div>
                                            <button className="round-menu d-lg-none bg-transparent border-0" onClick={showMobilemenu}>
                                                <i className="bi bi-list" style={{ fontSize: '30px', color: 'white' }} />
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* Progress Bar */}
                    <div style={{
                        transform: `translateX(${completion - 100}%)`,
                        background: '#913bff', height: '4px', width: '100%',
                        transition: 'transform 0.2s linear'
                    }} />
                </div>
                <MobileMenu onClick={hideMobilemenu} active={menu} />
            </header>
        </Fragment>
    );
};

export default ThemeMenuOne;